"use client";

import { useState } from "react";
import { createClient } from "@/lib/supabase/client";
import { Button } from "@/components/ui/button";
import Image from "next/image";
import { useSearchParams } from "next/navigation";
import { Loader2 } from "lucide-react";
import google from "@/public/brands/google.svg";
import { env } from "@/app/env";
import { rememberLoginMethod } from "@/lib/analytics/auth-tracking";

export function GoogleOAuthButton() {
  const searchParams = useSearchParams();
  const [loading, setLoading] = useState(false);

  const handleGoogleSignIn = async () => {
    if (loading) {
      return;
    }
    setLoading(true);
    const supabase = createClient();
    const searchString = searchParams.toString();
    const redirectTo = `${env.NEXT_PUBLIC_APP_URL}/auth/callback${searchString ? `?${searchString}` : ""}`;
    console.log("Redirecting to", redirectTo);

    const { error } = await supabase.auth.signInWithOAuth({
      provider: "google",
      options: {
        redirectTo,
      },
    });

    rememberLoginMethod("google_oauth");

    if (error) {
      setLoading(false);
    }
  };

  return (
    <Button
      variant="outline"
      className="w-full flex items-center justify-center gap-2"
      type="button"
      disabled={loading}
      onClick={handleGoogleSignIn}
    >
      {loading ? (
        <Loader2 className="h-5 w-5 animate-spin" />
      ) : (
        <Image src={google} alt="Google" width={24} height={24} className="mr-2" />
      )}
      {loading ? "Redirecting..." : "Sign in with Google"}
    </Button>
  );
}
